import * as GSAP from 'gsap';
import AbstractElement from "./AbstractElement";
import CarouselTab from "../components/tab/CarouselTab";
import SectionTab from "../components/tab/SectionTab";
import Product from "../components/product/Product";
import MosaicEffect from "../components/MosaicEffect";
import CSSTransitionInElement from "../components/CSSTransitionInElement";


class PerformanceElement extends AbstractElement {


    constructor(template: JQuery) {
        super(template);
    }


    resize(): void {
        this.update();
    }

    update(scrollTop?: number): void {
        if (this.banner) this.banner.update(scrollTop, window.innerHeight / 3);
        if (this.title) this.title.update(scrollTop, window.innerHeight / 3);
        if (this.desc) this.desc.update(scrollTop, window.innerHeight / 3);
        if (this.divider) this.divider.update(scrollTop, window.innerHeight / 2);
        if (this.mosaic) this.mosaic.update(scrollTop, window.innerHeight / 3);
    }

    private banner: CSSTransitionInElement;
    private title: CSSTransitionInElement;
    private desc: CSSTransitionInElement;
    private divider: CSSTransitionInElement;
    private mosaic: MosaicEffect;

    init(): void {

        const $intro = this.template.find('.section__intro');
        this.banner = new CSSTransitionInElement($intro.find('.section__banner'));
        this.title = new CSSTransitionInElement($intro.find('.section__info__title'));
        this.desc = new CSSTransitionInElement($intro.find('.section__info__desc'));
        this.divider = new CSSTransitionInElement(this.template.find('.tab__divider'));
        this.mosaic = new MosaicEffect(this.template.find('.mosaic'));
        this.initTabs();
    }




    private initTabs(): void {

        const tabPerformance = new SectionTab(this.template.find('#tabPerformance'));
        tabPerformance.changeBgColor('#0f0f0f');

        const tabPowerSolution = new CarouselTab(this.template.find('#tabPowerSolution'));
        tabPowerSolution.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPerformance.changeContentHeight();
        });
        tabPowerSolution.emitter.on('CHANGE_BG_COLOR', (data: any) => {
            tabPerformance.changeBgColor(data.bgColor);
        });
        tabPowerSolution.initCarousel({
            items: 1,
            loop: false,
            margin: 0,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            autoHeight: true
        });

        const tabPowerArchitecture = new CarouselTab(this.template.find('#tabPowerArchitecture'));
        tabPowerArchitecture.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPowerSolution.refreshCarousel();
        });
        tabPowerArchitecture.initCarousel({
            items: 1,
            loop: false,
            margin: 10,
            nav: false,
            dots: false,
            mouseDrag: false,
            touchDrag: false,
            autoHeight: true
        });

        const productPowerDesign = new Product(this.template.find('#productPowerDesign'));
        productPowerDesign.emitter.on('CAROUSEL_REFRESHED', () => {
            tabPerformance.changeContentHeight();
        });
    }


}

export default PerformanceElement;